// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Goals__goalCountText___NQTa6 {
    text-align: center;
    color: #b1b1b1;
}

.Goals__upcomingChart___I8d6h {
    text-align: center;
}

.Goals__marginLeft1em___fvizp {
    margin-left: 1em;
}

.Goals__marginRight1em___rq_fk {
    margin-right: 1em;
}

.Goals__titleText___VXrbM {
    text-align: center;
    font-family: IM Fell French Canon SC;
    color: darkgoldenrod;
    font-size: 1.1em;
    margin-top: 1em;
}

.Goals__centerText___DAtdt {
    text-align: center;
}

.Goals__fontBold___lGEdA {
    font-weight: bold;
}

.Goals__displayBlock___dS79W {
    display: block;
}

.Goals__displayInline___GlvtB {
    display: inline;
}

.Goals__goalsCompleteText___ordEi {
    color: greenyellow;
    display: block;
}

.Goals__goalsRemainingText_Normal___O6J6G {
    display: block;
    margin: 10px; 
}

.Goals__goalsRemainingText_After8pm___OQr1o {
    display: block;
    margin-top: 10px;
    color: white;
    background: red;
    font-weight: bold;
}

.Goals__goalSearch___vWp3O {
    max-width: 235px;
    margin-bottom: 0.5em;
    margin-top: 0;
}

.Goals__chevron___g_0XH {
    margin-left: 10px;
    position: relative;
    top: 2px;
}

.Goals__searchChevronPanel___EVfwZ {
    margin: 6px 0px;
}

.Goals__panelTopGap___TWvVv {
    margin-top: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"goalCountText": `Goals__goalCountText___NQTa6`,
	"upcomingChart": `Goals__upcomingChart___I8d6h`,
	"marginLeft1em": `Goals__marginLeft1em___fvizp`,
	"marginRight1em": `Goals__marginRight1em___rq_fk`,
	"titleText": `Goals__titleText___VXrbM`,
	"centerText": `Goals__centerText___DAtdt`,
	"fontBold": `Goals__fontBold___lGEdA`,
	"displayBlock": `Goals__displayBlock___dS79W`,
	"displayInline": `Goals__displayInline___GlvtB`,
	"goalsCompleteText": `Goals__goalsCompleteText___ordEi`,
	"goalsRemainingText_Normal": `Goals__goalsRemainingText_Normal___O6J6G`,
	"goalsRemainingText_After8pm": `Goals__goalsRemainingText_After8pm___OQr1o`,
	"goalSearch": `Goals__goalSearch___vWp3O`,
	"chevron": `Goals__chevron___g_0XH`,
	"searchChevronPanel": `Goals__searchChevronPanel___EVfwZ`,
	"panelTopGap": `Goals__panelTopGap___TWvVv`
};
module.exports = ___CSS_LOADER_EXPORT___;
